import React from 'react';

const Hero = ({ onContactClick, onScheduleClick }) => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h2 className="hero-headline">Shree Aesthetics</h2>
            <i className="hero-subtitle">By Dr. Deepika</i>
            <p className="hero-subtext">A Trusted Centre for Cosmetic & Reconstructive Care</p>
            <button className="contact-btn" onClick={onScheduleClick}>
              <i className="fas fa-calendar-plus"></i>
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;